// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__dGCNt","title":"FrontImage_title__36K5l"};